import React from 'react'
import Portal from '../../../../component/portal'
import './index.scss'
import { parseQueryString, transformQueryString, i18n } from '../../../../common/util'
import { MName } from '../../../../config'
import { AppContext } from '../../../../config/context'

class Jump extends React.Component {
    constructor() {
        super(...arguments)
    }

    cancel = () => {
        try {
            if (window.history.length < 2) {
                window.close()
            }
            window.history.back()
            window.history.forward()
        } catch (e) {
            window.close()
        }
    }

    submit = () => {
        const query = parseQueryString(location.search)
        const host = query.targetHost
        delete query.targetHost
        const path = query.targetPath
        delete query.targetPath
        location.href = host + path + transformQueryString(query)
    }

    render() {
        const { lang } = this.context.user
        return <div>
            <div className="jump-logo"></div>
            <div className="jump-wrapper">
                <p className="jump-title">{i18n(`正在进入${MName}-香港站`, lang)}</p>
                <div className="jump-loading-wrapper">
                    <div className="jump-loading"></div>
                </div>
                <div className="jump-btns">
                    <button className="jump-cancel" onClick={this.cancel}>{i18n('取消', lang)}</button>
                    <button className="jump-submit" onClick={this.submit}>{i18n('确定', lang)}</button>
                </div>
            </div>
        </div>
    }
}

Jump.contextType = AppContext

export default Portal(Jump, 'page-jump-container')